var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"pagebox",style:({
        width: ((_vm.chartInfo.position.width) + "px"),
        height: ((_vm.chartInfo.position.height) + "px"),
        transform: _vm.chartInfo.position.pageMt,
    })},[_c('div',{ref:"main",staticClass:"shapebox",style:({
            transform: _vm.chartInfo.position.shapetMt,
        }),on:{"click":_vm.clickShapebox,"mousemove":_vm.moveOnShapebox,"dblclick":function($event){$event.stopPropagation();return _vm.showEditor($event)},"mousedown":_vm.handleMousedown,"mouseleave":_vm.handleLeave}}),_c('div',{ref:"svgMain",staticClass:"shapebox outScreen",style:({
            transform: _vm.chartInfo.position.shapetMt,
        })})])}
var staticRenderFns = []

export { render, staticRenderFns }